import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useAuthStore } from '@/stores/useAuthStore'

export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const storeAuth = useAuthStore()

return (_ctx: any,_cache: any) => {
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_unref(storeAuth).isAuth)
    ? (_openBlock(), _createBlock(_component_v_footer, {
        key: 0,
        app: "",
        absolute: "",
        class: "d-flex text-caption justify-center bg-transparent pb-4"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Luzern Solutions ©" + _toDisplayString(new Date().getFullYear()), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})